<template>
  <div id="customer_form">
    <c-input v-model:value="customer.name" :type="'text'" :placeholder="placeholderName"/>
    <c-input v-model:value="customer.firstName" :type="'text'"
             :placeholder="placeholderFirstName"/>
    <c-input v-model:value="customer.email" :type="'mail'"
             :class="{'border border-red-600':emailError}" :placeholder="placeholderEmail"/>
    <c-input v-model:value="customer.gsm" :type="'text'" :placeholder="placeholderPhone"/>
    <c-option v-model:value="customer.ambience" :options="ambiences"
              :placeholder="$t('customer.ambience')"/>
  </div>
</template>

<script>
import OptionsDropdown from '@/components/form/OptionsDropdown';
import Input from '@/components/form/Input';
import validation from '@/mixins/validation';
import customerDataVerification from '@/mixins/customerDataVerification';

export default {
  name: 'CustomerForm',

  mixins: [validation, customerDataVerification],

  props: {
    customer: { required: true },
    asProfessional: {
      required: false,
      default: false
    }
  },

  components: {
    'c-option': OptionsDropdown,
    'c-input': Input,
  },

  data() {
    return {
      name: '',
      firstName: '',
      email: '',
      gsm: '',
      ambience: null,
    };
  },

  computed: {
    placeholderName() {
      return this.asProfessional ? this.$t('customer.nameCustomer') : this.$t('customer.name');
    },

    placeholderFirstName() {
      return this.asProfessional ? this.$t('customer.firstNameCustomer') : this.$t('customer.firstName');
    },

    placeholderEmail() {
      return this.asProfessional ? this.$t('customer.emailCustomer') : this.$t('customer.email');
    },

    placeholderPhone() {
      return this.asProfessional ? this.$t('customer.gsmCustomer') : this.$t('customer.gsm');
    },

    ambiences() {
      return this.$store.getters.getAmbiences.map((ambience) => {
        return {
          id: ambience.id,
          value: this.$i18n.locale === 'fr' ? ambience.nameFr : ambience.name
        };
      });
    },
  },

  watch: {
    customer() {
      this.$emit('update:customer', this.customer);
    }
  },
};
</script>
<style scoped>
#customer_form {
  max-width: 600px;
  @apply grid grid-rows-5 gap-y-5 m-0 mx-auto;
}
</style>
